module.exports = __webpack_public_path__ + "img/total-users.e1672505.svg";